import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "avatar guest"
}
const _hoisted_2 = {
  key: 2,
  class: "avatar bot"
}
const _hoisted_3 = ["src", "width", "height", "alt"]
const _hoisted_4 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcAvatar = _resolveComponent("NcAvatar")
  const _component_WebIcon = _resolveComponent("WebIcon")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar-wrapper", $options.avatarClass]),
    style: _normalizeStyle($options.avatarStyle)
  }, [
    ($options.iconClass)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["avatar icon", [$options.iconClass]])
        }, null, 2))
      : ($options.isGuestUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($options.firstLetterOfGuestName), 1))
        : ($options.isBot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " >_ "))
          : ($options.isFederatedUser && $props.token)
            ? (_openBlock(), _createElementBlock("img", {
                key: $options.avatarUrl,
                src: $options.avatarUrl,
                width: $props.size,
                height: $props.size,
                alt: $props.name,
                class: "avatar icon",
                onError: _cache[0] || (_cache[0] = $event => ($setup.failed = true))
              }, null, 40, _hoisted_3))
            : (_openBlock(), _createBlock(_component_NcAvatar, {
                key: $props.id + ($setup.isDarkTheme ? '-dark' : '-light'),
                user: $props.id,
                "display-name": $props.name,
                "menu-container": $props.menuContainer,
                "disable-tooltip": $props.disableTooltip,
                "disable-menu": $props.disableMenu,
                "hide-status": !$props.showUserStatus,
                "verbose-status": !$props.showUserStatusCompact,
                "preloaded-user-status": $props.preloadedUserStatus,
                size: $props.size
              }, null, 8, ["user", "display-name", "menu-container", "disable-tooltip", "disable-menu", "hide-status", "verbose-status", "preloaded-user-status", "size"])),
    ($props.showUserStatus && $options.isFederatedUser)
      ? (_openBlock(), _createElementBlock("span", {
          key: 5,
          class: "avatar-wrapper__user-status",
          role: "img",
          "aria-hidden": "false",
          "aria-label": $options.t('spreed', 'Federated user')
        }, [
          _createVNode(_component_WebIcon, { size: 14 })
        ], 8, _hoisted_4))
      : _createCommentVNode("", true),
    ($props.loading)
      ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
          key: 6,
          size: $props.size / 2,
          class: "loading-avatar"
        }, null, 8, ["size"]))
      : _createCommentVNode("", true)
  ], 6))
}